<template>
  <div class="content has-text-centered">
    <div id="formContainer">
      <form
        id="newMaster"
        @submit.prevent
      >
        <div class="filterHolder">
          <label>{{ $t("display_name").tUpper() }}</label>
          <input
            class="input"
            type="text"
            id="display_name"
            name="display_name"
            v-model="formData.displayName"
          />
        </div>

        <div id="inputContainer1">
          <div id="performanceFeeContainer">
            <div class="filterHolder">
              <label class="filterLabel">{{ $t("performance_fee").tUpper() }}</label>
              <span class="select">
                <select
                  name="performance_fee"
                  v-model="formData.performanceFee"
                  id="performance_fee"
                >
                  <option value="0">0</option>
                  <option value="5">5%</option>
                  <option value="10">10%</option>
                  <option value="15">15%</option>
                  <option value="20">20%</option>
                  <option value="25">25%</option>
                  <option value="30">30%</option>
                  <option value="50">50%</option>%
                </select>
              </span>
            </div>
          </div>

          <div id="minimumDepositContainer">
            <div class="filterHolder">
              <label class="filterLabel">{{ $t("minimum_deposit").tUpper() }}</label>
              <input
                class="input"
                type="text"
                id="minimum_deposit"
                name="minimum_deposit"
                v-model="formData.minimumDeposit"
              />
            </div>
          </div>
        </div>

        <div>
          <div id="platformContainer">
            <div class="filterHolder">
              <label class="filterLabel">{{ $t("platform").tUpper() }}</label>
              <span class="select">
                <select
                  name="platform"
                  v-model="formData.platform"
                  id="platform"
                >
                  <option value="mt4">MT4</option>
                  <option value="mt5">MT5</option>
                </select>
              </span>
            </div>
          </div>

          <div id="currencyContainer">
            <div class="filterHolder">
              <label class="filterLabel">{{ $t("currency").tUpper() }}</label>
              <span class="select">
                <select
                  name="currency"
                  v-model="formData.currency"
                  id="currency"
                >
                  <option value="USD">USD</option>
                  <option value="EUR">EUR</option>
                  <option value="GBP">GBP</option>
                </select>
              </span>
            </div>
          </div>
        </div>

        <div style="clear:both"></div>
        <div id="inputContainer2">
          <p id="checkboxPrivateContainer">
            <input
              type="checkbox"
              name="private"
              v-model="formData.private"
              id="private"
            />
            <label for="private">{{ $t("private_master_account").tTitle() }}</label>
          </p>
          <p id="checkboxLockedWithdrawalsContainer">
            <input
              type="checkbox"
              name="locked_withdrawals"
              v-model="formData.lockedWithdrawals"
              id="locked_withdrawals"
            />
            <label for="locked_withdrawals">{{ $t("reject_withdrawls_during_open_trades").tTitle() }}</label>
          </p>
          <button
            id="submitNewMasterBtn"
            class="button is-primary is-pulled-right"
            @click="createMasterAccount()"
          >{{ $t("submit").tUpper() }}</button>
          <div style="clear:both"></div>
        </div>
      </form>
    </div>

    <hr />
    <table
      id="masterAccounts"
      class="table is-responsive"
      :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
    >
      <thead>
        <tr>
          <th>{{ $t("trading_account").tUpper() }}</th>
          <th>{{ $t("display_name").tUpper() }}</th>
          <th>{{ $t("performance_fee").tUpper() }}</th>
          <th>{{ $t("minimum_deposit").tUpper() }}</th>
          <th>{{ $t("approved").tUpper() }}</th>
          <th>{{ $t("private").tUpper() }}</th>
          <th>{{ $t("private_code").tUpper() }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="accounts in userPammMasterAccounts"
          :key="accounts.trading_account"
        >
          <td>{{accounts.trading_account}}</td>
          <td>{{accounts.name}}</td>
          <td>{{accounts.performance_fee}}</td>
          <td>{{accounts.minimum_deposit}}</td>
          <td>{{accounts.approved}}</td>
          <td>{{accounts.private}}</td>
          <td>{{accounts.private_pw}}</td>
        </tr>
      </tbody>
    </table>

    <error-modal></error-modal>

  </div>
</template>

<script>
import { service } from '../../app'
import { mapActions, mapGetters } from 'vuex'
import ErrorModal from '../../components/ErrorModal'

export default {
  components: {
    ErrorModal,
  },
  data() {
    return {
      userPammMasterAccounts: [],
      formData: {
        displayName: '',
        performanceFee: 0,
        minimumDeposit: 0,
        private: false,
        lockedWithdrawals: false,
        platform: 'mt4',
        currency: 'USD',
      },
    }
  },
  computed: {
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
    }),
  },
  mounted() {
    this.getUserPammMasterAccounts()
  },
  watch: {},
  methods: {
    getUserPammMasterAccounts() {
      service.get('/pamm/user-master-accounts/' + this.User.info.ID).then(response => {
        this.userPammMasterAccounts = response.data.pammMasters
      })
    },
    createMasterAccount() {
      if (this.formData.displayName.length <= 0 || this.formData.displayName.length > 32) {
        this['errorModal/set']({ active: true, text: this.$t('pamm_modal_error') })
        return
      }

      if (
        Math.floor(this.formData.minimumDeposit) !== parseFloat(this.formData.minimumDeposit) ||
        isNaN(this.formData.minimumDeposit) ||
        this.formData.minimumDeposit < 0 ||
        this.formData.minimumDeposit > 1000000
      ) {
        this['errorModal/set']({ active: true, text: this.$t('pamm_modal_error1') })
        return
      }

      service
        .post('/pamm/create-master-account', {
          displayName: this.formData.displayName,
          performanceFee: parseInt(this.formData.performanceFee),
          minimumDeposit: parseInt(this.formData.minimumDeposit),
          private: this.boolToYesNo(this.formData.private),
          lockedWithdrawals: this.boolToYesNo(this.formData.lockedWithdrawals),
          platform: this.formData.platform,
          currency: this.formData.currency,
        })
        .then(response => {
          this.$toasted.success(this.$t('pamm_master_account_created_successfully'))
          this.$toasted.success(this.$t('password_generated_for_ta'), { duration: 7000 })
          this.displayName = ''
          this.getUserPammMasterAccounts()
        })
    },
    getMD5(str) {
      let md5 = require('md5')
      return md5(String(str))
    },
    boolToYesNo(b) {
      return b === true ? 'yes' : 'no'
    },
    ...mapActions(['logoLoader/set', 'errorModal/set']),
  },
}
</script>

<style lang="scss" scoped>
div#formContainer {
  text-align: left;
}

span.select,
select {
  width: 100%;
}
.filterLabel {
  color: #000000;
  margin-top: 6px;
  display: inline-block;
}

button#submitNewMasterBtn {
  width: 150px;
  margin-top: 5px;
}

div {
  &#performanceFeeContainer,
  &#platformContainer {
    width: 49%;
    float: left;
  }

  &#minimumDepositContainer,
  &#currencyContainer {
    width: 49%;
    float: right;
  }

  &#inputContainer2 {
    width: 100%;
    margin-top: 6px;

    > p {
      float: left;
      margin-top: 6px;
      margin-right: 5%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// new-master.vue?7023fd79